import { render } from "./ControlSidebar.vue?vue&type=template&id=00847c75"
import script from "./ControlSidebar.vue?vue&type=script&lang=js"
export * from "./ControlSidebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__